<template>

  <div class="video-player-container">

    <!-- 播放按钮 -->
    <div v-if="!videoPlay" class="video-play-btn" @click="playVideo"></div>

    <!-- 视频层 -->
    <video-player class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      style="width: 100%;height: 100%"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)">
    </video-player>



    <!-- 弹幕开关 -->
    <div class="danma-input" :class="{'danma-large' : danmaInput}" v-show="videoPlay">
      <van-form class="flex-1" @submit="onSubmit">
        <van-field :border="false" class="danma-text" maxlength="20" v-model.trim="danma" @focus="danmaFocus" @blur="danmaBlur" placeholder="点我发弹幕" />
      </van-form>
      <span class="danma-btn" :class="{'close':!isDanmaku}" @click.stop="onHandleSwitchDanmaku">弹</span>
    </div>

    <!-- 弹幕层 -->
    <div class="danmaku-box" :class="{'danmaku-show':isDanmaku}" @click="playVideo">
      <div id="danmaku"></div>
    </div>
  </div>
</template>

<script>
import easyDanmaku from "@/util/index";
import { Toast } from "vant";

let Danmaku;
export default {
  name: "Video",
  data() {
    return {
      danma: "",
      danmaData: [], // 弹幕数据
      danmaTimer: null,
      danmaInput: false,
      videoPlay: false, // 视频是否播放
      isDanmaku: true, // 弹幕是否打开
      playerOptions: {
        muted: false,
        autoplay: true,
        loop: true,
        controls: true,
        preload: true,
        sources: [
          {
            type: "video/mp4",
            src: "http://zhaopin.winning-health.com.cn/static/media/campus-video.mp4",
          },
        ],
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  mounted() {
    Danmaku = new easyDanmaku({
      el: "#danmaku", //弹幕挂载节点
      colourful: false, //彩色弹幕
      line: 5, //弹幕行数
      wrapperStyle: "danmaku-wrapper", //默认弹幕样式
      speed: 8, //弹幕播放速度
      runtime: 3, //播放一次的时常
      loop: false, //开启循环播放
      hover: false, //鼠标移入悬停
    });
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    isOtherBrowser(){
      let ua = window.navigator.userAgent.toLocaleLowerCase() || ''
      return  ua.indexOf('qqbrowser') !== -1 || ua.indexOf('ucbrowser') !==-1
    }
  },
  methods: {
    // 获取弹幕
    getDanmaku() {
      this.$api
        .api_get_bulletchat({
          seconds: 10,
          size: 50,
        })
        .then((res) => {
          if (res && res.length) {
            this.danmaData = res.map((danmu) => {
              if (danmu && danmu.content) {
                return danmu.content.split(":")[1];
              }
            });
            Danmaku && Danmaku.batchSend(this.danmaData);
          }
        });
    },
    // 弹幕定时器
    danmaInterval() {
      this.getDanmaku();
      this.danmaTimer = setInterval(() => {
        this.getDanmaku();
      }, 10000);
    },
    // 弹幕输入框获得焦点
    danmaFocus() {
      this.danmaInput = true;
    },
    // 弹幕输入框失去焦点
    danmaBlur() {
      this.danma ? (this.danmaInput = true) : (this.danmaInput = false);
    },
    // 提交弹幕
    onSubmit() {
      if (this.danma.length <= 0) {
        Toast("弹幕不能为空");
        return;
      }

      if (this.danma.length > 20) {
        Toast("弹幕不能超过20个字");
        return;
      }

      this.$api.api_send_bulletchat({ content: this.danma }).then(() => {
        // Toast('发送成功')
        this.danma = "";
        if (this.videoPlay) {
          // 视频播放中展示弹幕
          clearInterval(this.danmaTimer);
          this.danmaTimer = null;
          if (!this.danmaTimer) {
            this.danmaInterval();
          }
        }
      });
    },
    // 播放暂停视频
    playVideo() {
      this.videoPlay
        ? this.player && this.player.pause()
        : this.player && this.player.play();
    },

    // 播放回调
    onPlayerPlay() {
      this.videoPlay = true;
      if (this.isDanmaku) {
        // 弹幕打开
        if (!this.danmaTimer) {
          this.danmaInterval();
        }
        Danmaku && Danmaku.play();
      }
    },
    // 暂停回调
    onPlayerPause() {
      this.videoPlay = false;
      clearInterval(this.danmaTimer);
      this.danmaTimer = null;
      if (this.isDanmaku) {
        // 弹幕打开
        Danmaku && Danmaku.pause();
      }
    },
    // 弹幕开关
    onHandleSwitchDanmaku() {
      this.isDanmaku = !this.isDanmaku;
      if (this.isDanmaku) {
        // 弹幕打开
        if (!this.danmaTimer) {
          this.videoPlay && this.danmaInterval();
        }
        this.videoPlay && Danmaku && Danmaku.play();
      } else {
        // 弹幕关闭
        Danmaku && Danmaku.pause();
        clearInterval(this.danmaTimer);
        this.danmaTimer = null;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* 弹幕颜色 */
.default-style.danmaku-wrapper {
  color: #fff;
  font-size: 26px;
}
/* 隐藏播放按钮 */
.video-js .vjs-big-play-button {
  display: none !important;
}
/* 修正进度条位置 */
.video-js .vjs-control-bar{
 bottom: 0px !important;
 height: 40px !important;
}
/* 修正进度条圆点位置 */
.video-js .vjs-play-progress:before {
  top: -10px !important;
}
/* 修正时间文字位置 */
.video-js .vjs-time-control{
  display: flex;
  align-items: center;
}

/* 显示时间 */
.video-js .vjs-current-time, .video-js .vjs-duration{
  display: unset !important;
  display: flex;
  align-items: center;
  height: 40px !important;
  line-height: 40px !important;
}



</style>

<style scoped>

::v-deep .vjs-button > .vjs-icon-placeholder:before{
  font-size:30px;
  line-height:40px;
}

::v-deep .video-js .vjs-time-control{
  font-size:20px;
  padding-left:5px;
  padding-right:5px;
}

::v-deep .video-js  .vjs-time-divider{
  min-width:5px;
}

::v-deep .video-js .vjs-progress-holder{
  height:8px;
}

::v-deep .video-js .vjs-play-progress:before{
  font-size:26px;
}

.video-player-container {
  position: relative;
  height: 100%;
}

::v-deep .video-js {
  width: 100%;
  height: 100%;
}

.danmaku-box {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 360px;
  opacity: 0;
}

.danmaku-show {
  opacity: 1;
}

#danmaku {
  width: 100%;
  height: 100%;
}

.danma-input {
  width: 226px;
  background: rgba(242, 242, 242, 0.2);
  border-radius: 33px;
  display: flex;
  align-items: center;
  font-size: 26px;
  overflow: hidden;
  position: absolute;
  bottom: 40px !important;
  right: 20px;
  border-radius: 33px;
  height: 66px;
  z-index: 999;
  transition: width 0.5s;
  -moz-transition: width 0.5s;
  -webkit-transition: width 0.5s;
  -o-transition: width 0.5s;
}

.danma-input.danma-large {
  width: 400px;
  transition: width 0.5s;
  -moz-transition: width 0.5s;
  -webkit-transition: width 0.5s;
  -o-transition: width 0.5s;
}

.danma-btn {
  display: block;
  padding: 14px 23px 14px 16px;
  font-size: 28px;
  font-weight: bold;
  background: rgba(251, 251, 251, 0.24);
  position: relative;
  color: #fff;
}

.danma-btn::after {
  display: block;
  content: "";
  width: 20px;
  height: 20px;
  background: url(../assets/images/danma-open.svg);
  background-size: 20px 20px;
  position: absolute;
  bottom: 10px;
  right: 16px;
}

.danma-btn.close::after {
  background-image: url(../assets/images/danma-close.svg);
}

::v-deep .danma-text.van-cell {
  font-size: 26px;
  height: 66px;
  line-height: 45px;
  padding: 14px 16px;
  align-items: center;
  background: transparent;
}

::v-deep .danma-text .van-field__control {
  color: #fff;
}

.video-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 80px;
  height: 80px;
  background: url(../assets/images/video-play.svg);
  background-size: 80px 80px;
}

.flex-1 {
  flex: 1;
}
</style>
